import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  CircularProgress,
  Grid,
  Switch,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { CATEGORY_IMAGE_URL } from "../../constant";

const CategoryCard = ({
  item,
  isStatusLoading,
  isLoadingItemId,
  switchOnChange,
}) => {
  return (
    <Card>
      <CardMedia
        sx={{ height: 180 }}
        image={
          item.categoryImageOfWomen
            ? `${CATEGORY_IMAGE_URL}${item.categoryImageOfWomen}`
            : item.categoryImageOfMen
            ? `${CATEGORY_IMAGE_URL}${item.categoryImageOfMen}`
            : `${CATEGORY_IMAGE_URL}${item.categoryImageOfKids}`
        }
        title={item.categoryName}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {item.categoryName}
        </Typography>
      </CardContent>
      <CardActions sx={{ mt: "-20px" }}>
        <Grid container>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Link to={`/category/${item._id}`}>
              <Button size="small">Edit</Button>
            </Link>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {isStatusLoading && isLoadingItemId === item._id ? (
              <CircularProgress
                color="inherit"
                size="20px"
                sx={{ mr: "20px", mb: "18px" }}
              />
            ) : (
              <Switch
                checked={item.status === "A" ? true : false}
                onChange={switchOnChange}
              />
            )}
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default CategoryCard;
